import { isMobileClient } from '../components/DetectBrowser/DetectBrowser'

export interface IThemeInterface {
  breakpoints: {
    mobile: string
    tablet: string
  }
  colors: {
    palette: {
      airbnb: string
      boxbuy: string
      emerald: string
      darkGrey: string
      almostBlack: string
      lightGrey: string
      silver: string
      warmGrey: string
      white: string
      greyish: string
      warmPreyTwo: string
      paleGrey: string
      pinkishGrey: string
      greyishBrown: string
      darkGreyTwo: string
      slateGrey: string
      tangerine: string
      azure: string
      warmGreytThree: string
      battleshipGrey: string
      black: string
      seafoamBlue: string
      beige: string
      pinkishTan: string
      kelleyGreen: string
      greyTwo: string
      greyishBrownTwo: string
      whiteTwo: string
      slateGreyTwo: string
      booking: string
      icalendar: string
      reddish: string
    }
    error: string
    disabled: string
    primary: string
    warning: string
    placeholder: string
    border: string

    header: {
      background: string
      gridBorder: string
      selected: string
      today: string
      weekend: string
    }
    calendar: {
      background: string
      gridBorder: string
      hasIntegration: string
      hovered: string
      today: string
      weekend: string
    }
    datepicker: {
      selected: string
      hover: string
      selectedSpan: string
      hoverLabel: string
      selectedSpanHover: string
      highlighted: string
    }
    form: {
      label: string
    }
  }
  calendar: {
    header: {
      height: number
      width: number
    }
    room: {
      height: number
      width: number
    }
  }
}

function calcRoomWidth() {
  return isMobileClient() ? 125 : 220
}

export default {
  breakpoints: {
    mobile: '1024px',
    tablet: '1025px',
  },
  calendar: {
    header: {
      height: 46, // * Number(process.env.REACT_APP_CALENDAR_SCALE),
      width: 56, // * Number(process.env.REACT_APP_CALENDAR_SCALE),
    },
    room: {
      height: 60, // * Number(process.env.REACT_APP_CALENDAR_SCALE),
      width: calcRoomWidth(), // * Number(process.env.REACT_APP_CALENDAR_SCALE),
    },
  },
  colors: {
    border: 'rgb(196,197,199)',
    calendar: {
      background: 'white',
      gridBorder: 'rgb(223,223,223)',
      hasIntegration: 'rgb(141,93,192)',
      hovered: 'rgb(0,0,0)',
      today: 'rgba(0,165,65,.15)',
      weekend: 'rgb(235,237,239)',
    },
    datepicker: {
      highlighted: '#00a541',
      hover: '#aaebc3',
      hoverLabel: '#696a6d',
      selected: '#00a541',
      selectedSpan: '#36b569',
      selectedSpanHover: '#30a45e',
    },
    error: '#e49f9f',
    disabled: '#f2f2f2',
    form: {
      label: '#696a6d',
    },
    header: {
      background: 'white',
      gridBorder: 'rgb(223, 223, 223)',
      selected: 'rgb(225, 225, 225)',
      today: 'rgb(0, 165, 65)',
      weekend: 'rgb(223, 223, 223)',
    },
    palette: {
      airbnb: '#FF5A5F',
      boxbuy: '#00a541',
      almostBlack: '#101213',
      azure: '#0091f7',
      battleshipGrey: '#727376',
      beige: '#e7be9a',
      black: '#000000',
      booking: 'rgb(31,57,117)',
      darkGrey: '#303133',
      darkGreyTwo: '#272728',
      emerald: '#00a541',
      greyTwo: '#dfdfdf',
      greyish: '#a8a8a8',
      greyishBrown: '#3e3e3e',
      greyishBrownTwo: '#404040',
      icalendar: '#FFCE35',
      kelleyGreen: '#007d31',
      lightGrey: '#e1e1e1',
      paleGrey: '#ebedef',
      pinkishGrey: '#cecece',
      pinkishTan: '#e49f9f',
      reddish: '#bf3333',
      seafoamBlue: '#8ad9a9',
      silver: '#cecfcf',
      slateGrey: '#696a6d',
      slateGreyTwo: '#606569',
      tangerine: '#f79d00',
      warmGrey: '#777777',
      warmGreytThree: '#a1a1a1',
      warmPreyTwo: '#909090',
      white: '#ffffff',
      whiteTwo: '#d7d7d7',
    },
    placeholder: '#969696',
    primary: '#00a541',
    warning: '#e7be9a',
  },
} as IThemeInterface
